import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import {
  PRIORITY_OPTIONS,
  RESPONSE_STATUS_OPTIONS,
  RESPONSES_SORT_OPTIONS,
  RESPONSES_SITE_OPTIONS,
} from "../utils/survey-manager.helper";

const ResponsesFilter = ({
  filters,
  stats,
  onSearch,
  onSurveyChange,
  onSiteChange,
  onStatusChange,
  onPriorityChange,
  onSortChange,
}) => {
  const { t } = useTran();

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* Search */}
      <div className="relative w-64">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          className="pl-9 h-9 text-sm"
          placeholder={t("Search by name or company...")}
          value={filters.search}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      {/* Survey */}
      <SelectField
        value={filters.surveyId}
        onChange={(e) => onSurveyChange(e.target.value)}
        options={stats.surveyOptions}
        className="h-9 text-sm w-36"
      />
      {/* Site */}
      <SelectField
        value={filters.site}
        onChange={(e) => onSiteChange(e.target.value)}
        options={RESPONSES_SITE_OPTIONS}
        className="h-9 text-sm w-36"
      />

      {/* Status */}
      <SelectField
        value={filters.status}
        onChange={(e) => onStatusChange(e.target.value)}
        options={RESPONSE_STATUS_OPTIONS}
        className="h-9 text-sm w-36"
      />

      {/* Priority */}
      <SelectField
        value={filters.priorityLabel}
        onChange={(e) => onPriorityChange(e.target.value)}
        options={PRIORITY_OPTIONS}
        className="h-9 text-sm w-36"
      />

      {/* Sort — pushed to right */}
      <div className="ml-auto">
        <SelectField
          value={filters.sort}
          onChange={(e) => onSortChange(e.target.value)}
          options={RESPONSES_SORT_OPTIONS}
          className="h-9 text-sm w-48"
        />
      </div>
    </div>
  );
};

export default ResponsesFilter;
